import axios, {AxiosResponse} from "axios";
import {useRef, useState} from "react";
import FileSaver from "file-saver";

export const getFileNameFromRes = function (res: any, inline: boolean) {
    const type = inline ? (inline === true ? 'inline' : 'attachment') : 'attachment';
    let filename = '';
    //let disposition = res.headers('Content-Disposition');
    let disposition = res.headers['content-disposition'];
    if (disposition && disposition.indexOf(type) !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches !== null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    return filename;
};

interface DownloadFileProps {
    readonly apiDefinition: () => Promise<AxiosResponse<Blob>>;
    readonly preDownloading?: () => void;
    readonly postDownloading?: () => void;
    readonly onError?: () => void;
    readonly getFileName?: () => string;
}

interface DownloadedFileInfo {
    readonly download: () => Promise<void>;
    readonly open: () => Promise<void>;
    readonly ref: React.MutableRefObject<HTMLAnchorElement | null>; // il riferimento all'anchor per gestire il download
    readonly name: string | undefined;
    readonly url: string | undefined;
}

//https://levelup.gitconnected.com/react-custom-hook-typescript-to-download-a-file-through-api-b766046db18a
export const useDownloadFile = ({
                                    apiDefinition,
                                    preDownloading = () => {
                                    },
                                    postDownloading = () => {
                                    },
                                    onError = () => {
                                    },
                                    getFileName = () => 'file',
                                }: DownloadFileProps): DownloadedFileInfo => {
    const ref = useRef<HTMLAnchorElement | null>(null);
    const [url, setFileUrl] = useState<string>();
    const [name, setFileName] = useState<string>();

    const download = async () => {
        try {
            preDownloading();
            const res = await apiDefinition();
            const blob = new Blob([res.data], {type: 'application/pdf;charset=utf-8'})

            // N.B. non uso il costrutto con l'anchor, sfrutto FileSaver...
            //const url = URL.createObjectURL(blob);
            //window.open(url, '_blank');
            //setFileUrl(url);
            //setFileName(getFileNameFromRes(res, false) && getFileName());
            //ref.current?.click();
            //URL.revokeObjectURL(url);

            const fileName = getFileNameFromRes(res, false);
            FileSaver.saveAs(blob, (fileName !== '' ? fileName : 'file.pdf'));
            postDownloading();
        } catch (error) {
            console.log(error);
            onError();
        }
    };

    const open = async () => {
        try {
            preDownloading();
            const res = await apiDefinition();
            var blob = new Blob([res.data], {type: 'application/pdf;charset=utf-8'})
            const url = URL.createObjectURL(blob);
            // https://stackoverflow.com/questions/39657090/angularjs-open-pdf-in-new-tab-and-change-filename-url
            window.open(url, '_blank');
            postDownloading();
        } catch (error) {
            console.log(error);
            onError();
        }
    };

    return {download, open, ref, url, name};
};

export const downloadFile = (url: string | null | undefined, contentDisposition: 'attachment' | 'inline' = 'attachment') => {
    // throw new Error("uncomment this line to mock failure of API");
    if (!url)
        throw new Error("url is null or undefined");
    return axios.get(
        url,
        {
            params: {'contentDisposition': contentDisposition},
            headers: {'Accept': 'application/pdf,application/octet-stream'},
            responseType: 'arraybuffer', // Funziona anche con blob
            /*
                headers: {
                  Authorization: "Bearer <token>", // add authentication information as required by the backend APIs.
                },
            */
        }
    );
};

// https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios/75521884#75521884
// https://bobbyhadz.com/blog/download-file-using-axios
// Altra implementazione senza hook
export function axiosDownloadFile(url: string, fileName: string) {
    return axios({
        url,
        method: 'GET',
        params: {'contentDisposition': 'attachment'},
        headers: {'Accept': 'application/pdf,application/octet-stream'},
        responseType: 'arraybuffer',
    })
        .then(res => {
            const blob = new Blob([res.data], {type: 'application/pdf;charset=utf-8'});
            const href = window.URL.createObjectURL(blob);

            const anchorElement = document.createElement('a');

            anchorElement.href = href;
            anchorElement.setAttribute('download', `${fileName}`);

            document.body.appendChild(anchorElement);
            anchorElement.click();

            document.body.removeChild(anchorElement);
            window.URL.revokeObjectURL(href);
        })
        .catch(error => {
            console.log('error: ', error);
        });
}